export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Empresas.vue?vue&type=template&id=699d42b8&"


//////////////////
// WEBPACK FOOTER
// ./src/pages/user/Empresas.vue?vue&type=template&id=699d42b8&
// module id = 465
// module chunks = 1